import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'aa-panel-h1-a0-md1',
    templateUrl: './panel-h1-a0-md1.component.html',
    styleUrls: [
        '../panels.scss',
        './panel-h1-a0-md1.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PanelH1A0MD1Component
{
}
